import { state } from '@codesuma/baseline'
import { collection } from './storage'
import { DAY_COLORS, IDayColorChoice } from '../configs/day-colors'

// A day's own colour, when the reader has given it one: picked on the day
// page's last tab, and drawn as a circle under the day in the calendar (see the
// day cell). One row per coloured day, keyed by its Gregorian date, and no row
// at all for a day without one.
//
// The row keeps the colour's id, never a value: each theme draws an id in its
// own shade, so a day keeps its colour whichever theme it is read in.

export interface IDayColor {
    id: string // gy-gm-gd
    color: string // an id from configs/day-colors
}

type Day = { gy: number, gm: number, gd: number }

const KEY = 'day-colors'
const repo = collection<IDayColor>(KEY)
let all = new Map<string, string>()

export async function init() {
    all = new Map((await repo.load()).map(row => [row.id, row.color]))
}

const keyOf = (day: Day) => `${day.gy}-${day.gm}-${day.gd}`

// The colour's id, if the day has one.
function forDay(day: Day): string | undefined {
    return all.get(keyOf(day))
}

// The colour itself, to draw with (see paintDayColor). Nothing for a day
// without one, or with one this version no longer offers.
function colorOf(day: Day): IDayColorChoice | undefined {
    const id = forDay(day)
    return DAY_COLORS.find(c => c.id === id)
}

// A colour for the day, or null to take it off.
function set(day: Day, color: string | null) {
    const id = keyOf(day)
    if (color) {
        all.set(id, color)
        void repo.put({ id, color })
    } else {
        if (!all.has(id)) return
        all.delete(id)
        void repo.remove(id)
    }
    state.set(KEY, all)
}

export default { init, forDay, colorOf, set }
